// extracted by mini-css-extract-plugin
export default {"section-3-header":"Section3_section-3-header__o6VF9","section-3-grid":"Section3_section-3-grid__B09St"};